module.exports = __webpack_public_path__ + "img/sole-bicycles-JK6lD_y3aDg-unsplash.5779e1ec.jpg";